import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getCampaign = (state) => get(state, 'campaign.campaign');
export const getCampaignMessages = createSelector(getCampaign, (campaign) => campaign?.messages);

export const getCampaignTitle = createSelector(getCampaignMessages, (messages) => messages?.title);

export const getCampaignMessage = createSelector(getCampaignMessages, (messages) => messages?.message);

export const getCampaignTermsAndConditions = createSelector(getCampaignMessages, (messages) => messages?.termsAndConditions);

export const getCampaignPriceMessages = createSelector(
  getCampaignMessages,
  (messages) => messages?.priceMessages ?? { points: null, cash: null },
);

export const getPayWithToggleMessage = createSelector(getCampaignMessages, (messages) => messages?.payWithToggleMessage);

export const getCampaignUrl = createSelector(getCampaignMessages, (messages) => messages?.url);

export const getCampaignCountries = createSelector(getCampaign, (campaign) => campaign?.countries);
